export const imAuthRootPath = '/'
export const imAuthUiPath = '/app/imauth/ui/'
export const updatePassWord = imAuthUiPath + 'update-password'
export const resetPassword = imAuthUiPath + 'reset-password'
export const forgotPassWord = imAuthUiPath + 'forgot-password'
export const forgotUserName = imAuthUiPath + 'forgot-username'
export const password = imAuthUiPath + 'password'
export const expired = imAuthUiPath + 'expired'
export const twoFactorSetup = imAuthUiPath + 'two-factor-setup'
export const signInCertificate = imAuthUiPath + 'sign-in-certificate'
export const generateCertificate = imAuthUiPath + 'generate-certificate'
export const certificateError = imAuthUiPath + 'error-cac-2fa'
export const login = imAuthUiPath + 'login'
export const verifyOtp = imAuthUiPath + 'verify-otp'
export const termsOfUse = 'https://www.digicert.com/security-terms/'
export const privacyPolicy = 'https://www.digicert.com/digicert-privacy-policy'
export const legalRepository = 'https://www.digicert.com/legal-repository'
export const webTrustAudits = 'https://www.digicert.com/webtrust-audits'
export const support = 'https://www.digicert.com/support'
export const contactUs = 'https://www.digicert.com/contact-us'